import { useIntl } from 'react-intl';
export { IntlProvider } from 'react-intl';

var useFormatMessage = function () {
    var intl = useIntl();
    return function (message, values) {
        return intl.formatMessage(message, values);
    };
};

var useFormatDate = function () {
    var intl = useIntl();
    return function (value, options) {
        return intl.formatDate(value, options);
    };
};

var useFormatTime = function () {
    var intl = useIntl();
    return function (value, options) {
        return intl.formatTime(value, options);
    };
};

var useFormatRelativeTime = function () {
    var intl = useIntl();
    return function (value, unit, options) {
        return intl.formatRelativeTime(value, unit, options);
    };
};

var useFormatNumber = function () {
    var intl = useIntl();
    return function (value, options) {
        return intl.formatNumber(value, options);
    };
};

var useFormatPlural = function () {
    var intl = useIntl();
    return function (value, options) {
        return intl.formatPlural(value, options);
    };
};

var useFormatList = function () {
    var intl = useIntl();
    return function (value, options) {
        return intl.formatList(value, options);
    };
};

export { useFormatDate, useFormatList, useFormatMessage, useFormatNumber, useFormatPlural, useFormatRelativeTime, useFormatTime };
